// Glowfall theme — gallery, variant swatches, bundle quantity, add-on products, countdown
(function () {
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  // Money formatting (uses the store's money format from the form's data attribute)
  var form = $('#glowfall-form');
  var sec = $('#product'); var moneyFormat = (sec && sec.dataset.moneyFormat) || '${{amount}}';
  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDecimals.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withDecimals)
      .replace(/<[^>]*>/g, '');
  }

  // Gallery
  var main = $('#gallery-main'), counter = $('#gallery-counter'), thumbs = $$('#thumbs img');
  var current = 0;
  function show(i) {
    if (!thumbs.length) return;
    current = (i + thumbs.length) % thumbs.length;
    main.src = thumbs[current].dataset.full || thumbs[current].src;
    main.alt = thumbs[current].alt;
    if (counter) counter.textContent = (current + 1) + ' / ' + thumbs.length;
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === current); });
  }
  var prev = $('.gallery__arrow--prev'), next = $('.gallery__arrow--next');
  if (prev) prev.addEventListener('click', function () { show(current - 1); });
  if (next) next.addEventListener('click', function () { show(current + 1); });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.i); }); });
  if (thumbs.length) counter && (counter.textContent = '1 / ' + thumbs.length);

  if (!form) { countdown(); return; }

  // Variants
  var select = $('#variant-id', form);
  var swatchGroups = $$('.swatches', form);
  function selectedOptions() {
    return swatchGroups.map(function (g) { var a = $('.swatch.is-active', g); return a ? a.dataset.value : ''; });
  }
  function matchVariant() {
    var want = selectedOptions().join('|');
    var opts = $$('option', select);
    var hit = opts.filter(function (o) { return o.dataset.options === want; })[0];
    if (!hit) return;
    select.value = hit.value;
    var price = +hit.dataset.price, compare = +hit.dataset.compare;
    $('#price-now').textContent = money(price);
    var was = $('#price-was'), save = $('#price-save');
    if (was && compare > price) {
      was.textContent = money(compare); was.style.display = '';
      if (save) { save.textContent = '✦ SAVE ' + Math.round((1 - price / compare) * 100) + '%'; save.style.display = ''; }
    } else { if (was) was.style.display = 'none'; if (save) save.style.display = 'none'; }
    var btn = $('#add-to-cart');
    btn.disabled = hit.disabled;
    btn.textContent = hit.disabled ? 'SOLD OUT' : (btn.dataset.label || btn.textContent);
    if (hit.dataset.image) {
      var idx = thumbs.findIndex(function (t) { return (t.dataset.full || '').split('?')[0] === hit.dataset.image.split('?')[0]; });
      if (idx >= 0) show(idx);
    }
    recalc();
  }
  swatchGroups.forEach(function (g) {
    $$('.swatch', g).forEach(function (s) {
      s.addEventListener('click', function () {
        $$('.swatch', g).forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
        matchVariant();
      });
    });
  });
  $('#add-to-cart').dataset.label = $('#add-to-cart').textContent;

  // Bundle quantity + extras total
  var offers = $$('input[name="quantity"]', form), extras = $$('.extra-input', form);
  function recalc() {
    var opt = select.options[select.selectedIndex];
    var unit = opt ? +opt.dataset.price : 0;
    var qty = 1;
    offers.forEach(function (o) {
      var card = o.closest('.offer'); if (card) card.classList.toggle('is-active', o.checked);
      if (o.checked) qty = +o.value;
    });
    $$('.offer__price', form).forEach(function (e) { e.textContent = money(unit * +e.dataset.sets); });
    var total = unit * qty;
    extras.forEach(function (e) { if (e.checked) total += +e.dataset.price; });
    var t = $('#total'); if (t) t.textContent = money(total);
  }
  offers.forEach(function (o) { o.addEventListener('change', recalc); });
  extras.forEach(function (e) { e.addEventListener('change', recalc); });
  recalc();

  // Add to cart via AJAX (main product + any checked add-on products)
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var qty = 1; offers.forEach(function (o) { if (o.checked) qty = +o.value; });
    var items = [{ id: +select.value, quantity: qty }];
    extras.forEach(function (e) { if (e.checked) items.push({ id: +e.dataset.variant, quantity: 1 }); });
    var btn = $('#add-to-cart'); btn.disabled = true; btn.textContent = 'ADDING…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var c = $('#cart-count'); if (c) c.textContent = cart.item_count;
        btn.textContent = 'ADDED ✓';
        setTimeout(function () { btn.disabled = false; btn.textContent = btn.dataset.label; }, 1200);
        window.location.href = '/cart';
      })
      .catch(function () { btn.disabled = false; btn.textContent = btn.dataset.label; alert('Could not add to cart. Please try again.'); });
  });

  countdown();

  function countdown() {
    var h = $('#t-h'), m = $('#t-m'), s = $('#t-s');
    if (!h) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = new Date(), secs = 3600 - (now.getMinutes() * 60 + now.getSeconds());
      h.textContent = pad(Math.floor(secs / 3600)); m.textContent = pad(Math.floor((secs % 3600) / 60)); s.textContent = pad(secs % 60);
    }
    tick(); setInterval(tick, 1000);
  }
})();
